import { type FC, type ReactNode, type SVGProps, useRef } from "react";
import { CSSTransition } from "react-transition-group";
import { IconButton } from "src/components/Default/LekUI/Button";
import ArrowDownIcon from "src/images/Icons/newIcons/arrowDown.svg";
import ArrowUpIcon from "src/images/Icons/newIcons/arrowUp.svg";

interface LekAccordionProps {
	title: ReactNode;
	TitleIcon: FC<SVGProps<SVGSVGElement>>;
	children: ReactNode;
	Actions?: ReactNode;
	isOpen?: boolean;
	setIsOpen?: (isOpen: boolean) => void;
}

export const LekAccordion = ({
	title,
	TitleIcon,
	children,
	Actions = null,
	isOpen = true,
	setIsOpen,
}: LekAccordionProps) => {
	const ref = useRef<HTMLDivElement>(null);
	const Icon: FC<SVGProps<SVGSVGElement>> = isOpen ? ArrowUpIcon : ArrowDownIcon;

	return (
		<div className="content-box flex-col gap-16">
			<div className="flex w-100 justify-between">
				<div className="flex-center-row gap-8">
					<TitleIcon className="icon-normal" />
					<span>{title}</span>
				</div>
				<div className="flex gap-8">
					{Actions}
					{isOpen && setIsOpen && (
						<IconButton
							size="small"
							className="menu-icon-button"
							onClick={() => setIsOpen(!isOpen)}
							disableRipple
						>
							<Icon className="icon-small icon-primary" />
						</IconButton>
					)}
				</div>
			</div>
			<CSSTransition
				in={isOpen}
				timeout={200}
				classNames="collapse"
				unmountOnExit
				nodeRef={ref}
			>
				<div ref={ref}>{children}</div>
			</CSSTransition>
		</div>
	);
};
